import { z } from "zod";

export const whatsappChatSchema = z.object({
  id: z.string().nullable().optional(),
  type: z.string().nullable().optional(),
  name: z.string().nullable().optional(),
});

export type WhatsappChat = z.infer<typeof whatsappChatSchema>;

/** DRF-style pagination wrapper for orders */
export const paginatedWhatsappChatsSchema = z.object({
  count: z.number(),
  next: z.boolean().nullable(),
  previous: z.boolean().nullable(),
  results: z.array(whatsappChatSchema),
});

export type PaginatedWhatsappChats = z.infer<
  typeof paginatedWhatsappChatsSchema
>;
